import React from 'react';
import { createRoot } from 'react-dom/client';

import Login from './login';


createRoot(document.getElementById('app')).render(<Login />);
